export default "__VITE_ASSET__0046d2f0__"